<zv-dialog-wrapper [dataSource]="dwds"> {{ data.content }} </zv-dialog-wrapper>
